import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectToken } from "../../auth/auth.selector";
import OnlyDateFilter from "./OnlyDateFilter";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import { fetchApiData } from "../../../redux/reducers/commonApiSlice";
import { workoutLogs } from "../../../data/ApiEndpoints";
import {
  convertStraight,
  currentMonthCurrentDate,
  currentMonthStartDate,
} from "../../common-data/Converts";

const WorkoutLogs = ({ clickValues, sendableStatsQPs, from }) => {
  const token = useSelector(selectToken);
  const dispatch = useDispatch();
  const { data, loading, error } = useSelector((state) => state.common);

  const getInitialFilters = () => {
    if (clickValues?.workoutDate) {
      return {
        selectedStartDate: clickValues.workoutDate,
        selectedEndDate: clickValues.workoutDate,
      };
    }
    return {
      selectedStartDate: convertStraight(currentMonthStartDate),
      selectedEndDate: convertStraight(currentMonthCurrentDate),
    };
  };

  const iniAllFilters = getInitialFilters();
  const [allFilters, setAllFilters] = useState(iniAllFilters);
  const initialFilters = {
    user_id: "",
    date_from: "",
    date_to: "",
  };
  const [filters, setFilters] = useState(initialFilters);
  const iniTbDatas = {
    allData: null,
  };
  const [tbDatas, setTbDatas] = useState(iniTbDatas);

  const onClickReset = () => {
    const resetFilters = getInitialFilters();
    setAllFilters(resetFilters);
    setFilters(initialFilters);
  };

  useEffect(() => {
    if (clickValues?.workoutDate) {
      setAllFilters({
        selectedStartDate: clickValues.workoutDate,
        selectedEndDate: clickValues.workoutDate,
      });
    }
  }, [clickValues?.workoutDate]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,

      user_id: clickValues?.userId,
      date_from: allFilters.selectedStartDate || "",
      date_to: allFilters.selectedEndDate || "",
    }));
  }, [allFilters, sendableStatsQPs, clickValues?.userId]);

  useEffect(() => {
    if (filters.user_id) {
      dispatch(
        fetchApiData({
          method: "GET",
          endpoint: workoutLogs,
          payload: {
            filters: filters,
          },
          token: token,
        })
      );
    }
  }, [filters]);

  useEffect(() => {
    if (error) {
      console.error(error);
      setTbDatas(iniTbDatas);
    } else if (data?.status && data?.data) {
      setTbDatas((prevs) => ({
        ...prevs,
        allData: data.data || [],
      }));
    } else {
      console.error("Something Went Wrong!");
      setTbDatas(iniTbDatas);
    }
  }, [data, error]);

  const tbColumns = [
    {
      dataField: "name",
      text: "Member",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.name || "NA"}
            <br />
            {row?.mobile || ""}
          </span>
        );
      },
    },
    {
      dataField: "gym_name",
      text: "gym name",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.gym_name || "NA"}</span>;
      },
    },
    {
      dataField: "date",
      text: "Date",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth90">
            {" "}
            {row?.date ? row.date : "-"}
          </span>
        );
      },
    },
    {
      dataField: "workout_type",
      text: "Workout Type",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.workout_type || "-"}</span>;
      },
    },
    {
      dataField: "e_duration",
      text: "Duration",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.e_duration || "-"}</span>;
      },
    },
    {
      dataField: "e_calories",
      text: "Calorie",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.e_calories || "-"}</span>;
      },
    },
  ];

  return (
    <>
      <OnlyDateFilter
        filters={allFilters}
        setFilters={setAllFilters}
        onClickReset={onClickReset}
        MCLDate={true}
        from={from}
      />

      {tbDatas.allData?.length === 0 ? (
        <div className="error-container">
          <p>No workout logs found for this member.</p>
        </div>
      ) : (
        <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30">
          {loading ? (
            <ReactVortoxSpinner />
          ) : (
            <PaymentLinkTable
              tableData={tbDatas.allData}
              tableColumns={tbColumns}
            />
          )}
        </div>
      )}
    </>
  );
};

export default WorkoutLogs;
